import blackBack from '../../../../assets/images/card-back/black.png'
import blueBack from '../../../../assets/images/card-back/blue.png'
import brownBack from '../../../../assets/images/card-back/brown.png'
import greenBack from '../../../../assets/images/card-back/green.png'
import lightBlueBack from '../../../../assets/images/card-back/light_blue.png'
import redBack from '../../../../assets/images/card-back/red.png'
import { ECardBack } from '../../../../store/atoms/userSettings'

export const cardBackSourceByColor: Record<ECardBack, string> = {
  [ECardBack.BLACK]: blackBack,
  [ECardBack.BLUE]: blueBack,
  [ECardBack.GREEN]: greenBack,
  [ECardBack.LIGHT_BLUE]: lightBlueBack,
  [ECardBack.RED]: redBack,
  [ECardBack.BROWN]: brownBack,
}
